import React from 'react';
import { Link } from 'react-router-dom';
import './EmailConfirmed.css';

const EmailConfirmed = () => {
  return (
    <div className="email-confirmed-page">
      <div className="confirmation-container">
        <div className="success-animation">
          <div className="checkmark-circle">
            <svg className="checkmark" viewBox="0 0 52 52">
              <circle className="checkmark-circle-svg" cx="26" cy="26" r="25" fill="none"/>
              <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
          </div>
        </div>

        <h1 className="confirmation-title">Email Confirmed!</h1>
        <p className="confirmation-message">
          Thank you for confirming your email address. Your RunningAI Pro account is now fully activated.
        </p>

        <div className="next-steps">
          <h2>What's Next?</h2>
          <div className="steps-list">
            <div className="step-item">
              <div className="step-icon">📱</div>
              <div className="step-content">
                <h3>Open the RunningAI Pro App</h3>
                <p>Launch the app on your iOS device to start tracking your runs</p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-icon">🏃</div>
              <div className="step-content">
                <h3>Start Your First Run</h3>
                <p>Begin tracking your running journey with GPS precision</p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-icon">🧠</div>
              <div className="step-content">
                <h3>Chat with Your AI Coach</h3>
                <p>Get personalized advice and training plans from your AI running coach</p>
              </div>
            </div>
          </div>
        </div>

        <div className="action-buttons">
          <a href="runningai://open" className="primary-button">Open RunningAI Pro App</a>
          <Link to="/" className="secondary-button">Visit Website</Link>
        </div>

        <div className="help-section">
          <p className="help-text">
            Need help? <a href="mailto:support@runningaipro.com">Contact Support</a>
          </p>
        </div>
      </div>

      <footer className="footer">
        <p>&copy; 2026 RunningAI Pro. All rights reserved.</p>
        <div className="footer-links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/support">Support</Link>
        </div>
      </footer>
    </div>
  );
};

export default EmailConfirmed;
